import { $Q, $Qll } from "../utils/query-selector";
import { resetAndPauseVideo } from "./video-player";
import Swiper from "swiper";
import { Navigation, Pagination, Mousewheel, Thumbs, EffectFade } from 'swiper/modules';


const clampSwiperTranslate = (swiper) => {
  if (!swiper || swiper.destroyed || swiper.isLocked) {
    return;
  }

  const lastSlide = swiper.slides[swiper.slides.length - 1];
  const swiperStyles = window.getComputedStyle(swiper.el);
  const horizontalPadding =
    parseFloat(swiperStyles.paddingLeft) + parseFloat(swiperStyles.paddingRight);
  const visibleWidth = swiper.el.clientWidth - horizontalPadding;
  const contentWidth = lastSlide ? lastSlide.offsetLeft + lastSlide.offsetWidth : swiper.wrapperEl.scrollWidth;
  const minTranslate = Math.min(0, visibleWidth - contentWidth);
  const maxTranslate = 0;
  const nextTranslate = Math.min(maxTranslate, Math.max(minTranslate, swiper.translate));

  if (Math.abs(nextTranslate - swiper.translate) > 0.5) {
    swiper.setTranslate(nextTranslate);
    swiper.updateProgress(nextTranslate);
  }
};


export const mainProductSwiper = (query = '') => {
  let swiperProductThumbs = $Q(`#productMainSliderThumbs`);
  let swiperProductSlider = $Q(`#productMainSlider`);

  if (!swiperProductThumbs || !swiperProductSlider) {
    return;
  }

    window.MProductSwiperThumbs = new Swiper('#productMainSliderThumbs', {
      modules: [Pagination, Navigation, Thumbs],
      centeredSlides: false,
      centeredSlidesBounds: false,
      spaceBetween: 8,
      slidesPerView: "auto",
      slidesPerGroup: 1,
      freemode: false,
      watchOverflow: true,
      watchSlidesProgress: true,
      on: {
        afterInit: function () {
          this.el.classList.remove("jc-opacity-0")
          clampSwiperTranslate(this);
        },
        resize: function () {
          clampSwiperTranslate(this);
        },
        update: function () {
          clampSwiperTranslate(this);
        },
        transitionEnd: function () {
          clampSwiperTranslate(this);
        },
        setTranslate: function () {
          requestAnimationFrame(() => clampSwiperTranslate(this));
        },
      },
    });

    window.MProductSwiper = new Swiper("#productMainSlider", {
      modules: [Pagination, Navigation, Mousewheel, Thumbs],
      slidesPerView: 1,
      initialSlide: 0,
      slideToScroll: 1,
      cssMode: true,
      direction: "horizontal",
      autoHeight: true,
      thumbs: {
        swiper: window.MProductSwiperThumbs
      },
      breakpoints: { 
        992: {
          spaceBetween: 0,
          direction: "vertical",
          slidesPerView: "auto",
          freeMode: true,
          autoHeight: false,
        },
      },
      on: {
        slideChange: function () {
          requestAnimationFrame(() => clampSwiperTranslate(window.MProductSwiperThumbs));
          setTimeout(() => clampSwiperTranslate(window.MProductSwiperThumbs), 0);
        },
      },
    });


    if (document.querySelector(".video-popup:not(.swiper-initialized)")) {
      window.videoReviewPopup = new Swiper(".video-popup", {
        modules: [ Mousewheel, Pagination, Navigation, EffectFade],
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: false,
        loop: false,
        direction: "vertical",
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        navigation: { 
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }
      })
      window.videoReviewPopup.on('slideChange', function () {
        resetAndPauseVideo();
      });
    }
};


export const mainProductSwiperModal = (query = '') => {
  let swiperProductThumbs = $Q(`${query} .jc-main-product__swiper-thumbs`);
  let swiperProductSlider = $Q(`${query} .jc-main-product__swiper`);
  let swiperProductSliderPagination = $Q(`${query} .jc-main-product__swiper .swiper-pagination`);
  let productHandle = swiperProductSlider?.dataset.handle ? swiperProductSlider?.dataset.handle : '';
  let thumbsSize = swiperProductThumbs.querySelectorAll('.swiper-slide').length;
  let centerSlides = false;

  if (thumbsSize > 4) {
    thumbsSize = 4;
    centerSlides = false;
  }

  window.mainProductSwiperThumbs = new Swiper(swiperProductThumbs, {
    modules: [Pagination, Navigation, EffectFade, Thumbs],
    centeredSlides: centerSlides,
    centeredSlidesBounds: centerSlides,
    slidesPerGroup: 1,
    spaceBetween: 16,
    cssMode: true,
    slidesPerView: thumbsSize,
    threshold: '10px',
    breakpoints: {
      640: {
        slidesPerView: 3
      },
      768: {
        slidesPerView: 4
      },
      992: {
        slidesPerView: thumbsSize
      },
    },
    freemode: false,
    watchSlidesProgress: true,
    on: {
      afterInit: function () {
        this.el.classList.remove("jc-opacity-0")
      }
    },
  });

  if (!swiperProductSlider) {
    window.mainProductSwiperThumbs = null
  }


  window.mainSwiperModal = new Swiper(swiperProductSlider,
    {
      modules: [Pagination, Navigation, Thumbs],
      slidesPerView: 1,
      cssMode: true,
      thumbs: {
        swiper: window.mainProductSwiperThumbs
      },
      pagination: {
        el: swiperProductSliderPagination,
        clickable: true
      },
      navigation: {
        nextEl: $Q(`.modal-cart #main-product__swiper-next-${productHandle}`),
        prevEl: $Q(`.modal-cart #main-product__swiper-prev-${productHandle}`),
      }
    });

}
